module.exports = __webpack_public_path__ + "static/img/10.18492ca.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/3/eng/10.png
// module id = CMQL
// module chunks = 0